export default {
  title: "Заявка на участие в выставке",
  send: "Отправить",
  sent: "Отправлена",

  inviteAlreadySent: "На ваш адрес {0} уже был отправлен код участника для данной выставки.",
  resendInvite: "Отправить код участника повторно",
  inviteResentSuccessMessage: "Ваш код участника для выставки {0} отправлен на ваш адрес {1}. <br /><br /> Проверьте вашу почту.",

  modal: {
    contactPersonTitle: "Данные контактного лица",
    companyDetailsTitle: "Данные компании",
    eventDetailsTitle: "Данные для выставки",

    areaFieldTitle: "Необходимая площадь",
    areaFieldSqMeters: "кв. м",

    areaTypeFieldTitle: "Тип площади",
    areaTypeEquipped: "Оборудованная",
    areaTypeNotEquipped: "Необорудованная",

    subjectFieldTitle: "Тематический раздел"
  }
};
